import { render, staticRenderFns } from "./Masive.vue?vue&type=template&id=54e08ceb"
import script from "./Masive.vue?vue&type=script&lang=js"
export * from "./Masive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports